<template>
    <DCard
        padding
    >
        <DRow
            class="mb-3"
            align-vertical="end"
        >
            <DCol
                sm="2"
                class="pt-1"
            >
                <DInput
                    id="month"
                    v-model="filterParams.month"
                    :label="__('customers.contracts.partner_contracts.month')"
                    :placeholder="__('customers.contracts.partner_contracts.month')"
                    class="mb-0"
                />
            </DCol>
            <DCol
                sm="2"
                class="pt-1"
            >
                <DInput
                    id="reseller_customer_number"
                    v-model="filterParams.reseller_customer_number"
                    :label="__('customers.contracts.partner_contracts.reseller_customer_number')"
                    :placeholder="__('customers.contracts.partner_contracts.reseller_customer_number')"
                    class="mb-0"
                />
            </DCol>
            <DCol
                sm="2"
                class="pt-1"
            >
                <DInput
                    id="product_group"
                    v-model="filterParams.product_group"
                    :label="__('customers.contracts.partner_contracts.product_group')"
                    :placeholder="__('customers.contracts.partner_contracts.product_group')"
                    class="mb-0"
                />
            </DCol>
            <DCol
                sm="2"
                class="pt-1"
            >
                <DInput
                    id="end_customer_number"
                    v-model="filterParams.end_customer_number"
                    :label="__('customers.contracts.partner_contracts.end_customer_number')"
                    :placeholder="__('customers.contracts.partner_contracts.end_customer_number')"
                    class="mb-0"
                />
            </DCol>
            <DCol
                sm="3"
                class="d-flex gap-2"
            >
                <DButton
                    :label="__('messages.actions.filter')"
                    @click="changePage(partnerContracts.current_page)"
                />
                <DButton
                    icon="filter-off"
                    :label="__('messages.actions.reset_filter')"
                    @click="resetFilters"
                />
            </DCol>
        </DRow>
        <DTable
            class="table-responsive"
            :fields="fields"
            :items="partnerContracts.items"
            :sorter="isSortable"
            :sorter-value="sorterValue"
            @update:sorter-value="updateOrdering"
        >
            <template #distributor_name="{item}">
                <td>
                    {{ item.distributor_name === null ? '' : item.distributor_name }}
                </td>
            </template>
            <template #reseller="{item}">
                <td>
                    {{ item.reseller === null ? '' : item.reseller }}
                </td>
            </template>
            <template #reseller_customer_number="{item}">
                <td>
                    {{ item.reseller_customer_number === null ? '' : item.reseller_customer_number }}
                </td>
            </template>
            <template #object="{item}">
                <td>
                    {{ item.object === null ? '' : item.object }}
                </td>
            </template>
            <template #month="{item}">
                <td>
                    {{ item.month === null ? '' : item.month }}
                </td>
            </template>
            <template #end_customer="{item}">
                <td>
                    {{ item.end_customer === null ? '' : item.end_customer }}
                </td>
            </template>
            <template #end_customer_number="{item}">
                <td>
                    {{ item.end_customer_number === null ? '' : item.end_customer_number }}
                </td>
            </template>
            <template #start_date="{item}">
                <td>
                    {{ item.start_date === null ? '' : item.start_date }}
                </td>
            </template>
            <template #end_date="{item}">
                <td>
                    {{ item.end_date === null ? '' : item.end_date }}
                </td>
            </template>
        </DTable>
        <DPagination
            v-if="partnerContracts.last_page > 1"
            :active-page="partnerContracts.current_page"
            :pages="partnerContracts.last_page"
            align="center"
            @update:activePage="changePage"
        />
        <DFabs>
            <s-s-o-fab
                :customer="customer"
                @open-modal="showCreateCloudpitCustomerModal = true"
                @close-modal="showCreateCloudpitCustomerModal = false"
            />
        </DFabs>
        <CreateCloudPitCustomerModal
            :customer="customer"
            :show-modal="showCreateCloudpitCustomerModal"
            @close-modal="showCreateCloudpitCustomerModal = false"
        />
    </DCard>
</template>

<script>
import CustomerBase from '~@/Pages/Customers/Base'
import App from '~@/App.vue'

import SSOFab from '~@/Components/Customers/SSOFab'
import CreateCloudPitCustomerModal from '~@/Components/Customers/CreateCloudPitCustomerModal'

export default {
    name: 'CustomerPartnerContractShow',
    components: {
        SSOFab,
        CreateCloudPitCustomerModal
    },
    layout: [App, CustomerBase],
    props: {
        customer: {
            type: Object,
            default: () => { return {} }
        },
        contract: {
            type: Object,
            default: () => { return {} }
        },
        partnerContracts: {
            type: Object,
            default: () => { return {} }
        },
        filters: {
            type: Object,
            default: () => { return {} }
        }
    },
    data () {
        return {
            showCreateCloudpitCustomerModal: false,
            fields: [
                { key: 'id', label: this.__('customers.contracts.partner_contracts.id'), sorter: false },
                { key: 'distributor_id', label: this.__('customers.contracts.partner_contracts.distributor_id'), sorter: false },
                { key: 'distributor_name', label: this.__('customers.contracts.partner_contracts.distributor_name'), sorter: false },
                { key: 'reseller', label: this.__('customers.contracts.partner_contracts.reseller'), sorter: false },
                { key: 'reseller_customer_number', label: this.__('customers.contracts.partner_contracts.reseller_customer_number'), sorter: true },
                { key: 'article_number', label: this.__('customers.contracts.partner_contracts.article_number'), sorter: false },
                { key: 'product_group', label: this.__('customers.contracts.partner_contracts.product_group'), sorter: true },
                { key: 'article_name', label: this.__('customers.contracts.partner_contracts.article_name'), sorter: false },
                { key: 'quantity', label: this.__('customers.contracts.partner_contracts.quantity'), sorter: false },
                { key: 'price', label: this.__('customers.contracts.partner_contracts.price'), sorter: false },
                { key: 'object', label: this.__('customers.contracts.partner_contracts.object'), sorter: false },
                { key: 'month', label: this.__('customers.contracts.partner_contracts.month'), sorter: true },
                { key: 'end_customer', label: this.__('customers.contracts.partner_contracts.end_customer'), sorter: false },
                { key: 'end_customer_number', label: this.__('customers.contracts.partner_contracts.end_customer_number'), sorter: true },
                { key: 'start_date', label: this.__('customers.contracts.partner_contracts.start_date'), sorter: false },
                { key: 'end_date', label: this.__('customers.contracts.partner_contracts.end_date'), sorter: false },
                { key: 'sum', label: this.__('customers.contracts.partner_contracts.sum'), sorter: false }
            ],
            filterParams: this.filters
        }
    },
    computed: {
        userPermissions () {
            return this.$page.props.auth.permissions
        },
        sorterValue () {
            return {
                column: this.filters.order_by,
                asc: !!this.filters.order_by_asc
            }
        },
        isSortable () {
            if (!this.sorterValue.column) return false

            return { external: true }
        }
    },
    methods: {
        changePage (page) {
            const queryParameters = Object.fromEntries(Object.entries(this.filterParams).filter(([_, v]) => v))

            if (page !== 1) {
                queryParameters.page = page
            }

            this.$inertia.get(this.$route('customers.customers.contracts.partner_contracts', {
                customer: this.customer.id,
                contract: this.contract.id
            }), queryParameters)
        },
        resetFilters () {
            this.filterParams.reseller_customer_number = null
            this.filterParams.product_group = null
            this.filterParams.month = null
            this.filterParams.end_customer_number = null
            this.changePage(this.partnerContracts.current_page)
        },
        updateOrdering (event) {
            this.filterParams.order_by = event.column
            this.filterParams.order_by_asc = event.asc ? 1 : 0

            this.changePage(this.partnerContracts.current_page)
        }
    }
}
</script>
